export type SignalsRestApiStatus = {
    isConfigured: boolean;
    signalsCount: number;
};

export const DEFAULT_SIGNALS_REST_API_STATUS: SignalsRestApiStatus = {
    isConfigured: false,
    signalsCount: 0,
};
